import { render, staticRenderFns } from "./RegionCoverModal.vue?vue&type=template&id=59e921f9&scoped=true"
import script from "./RegionCoverModal.vue?vue&type=script&lang=ts"
export * from "./RegionCoverModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e921f9",
  null
  
)

export default component.exports